/**
 * i18n 語系持久化工具
 * 用於儲存和讀取用戶選擇的語系到瀏覽器 localStorage
 */

const LOCALE_STORAGE_KEY = 'user_locale';

export const LOCALE_OPTIONS = [
  { value: 'tw', label: '繁體中文' },
  { value: 'ch', label: '简体中文' },
  { value: 'en', label: 'English' },
] as const;

export type SupportedLocale = (typeof LOCALE_OPTIONS)[number]['value'];

export function isSupportedLocale(locale: string | null): locale is SupportedLocale {
  return LOCALE_OPTIONS.some((option) => option.value === locale);
}

/**
 * 儲存語系到 localStorage
 * @param locale 語系代碼 (例如: 'tw', 'en')
 */
export function saveLocale(locale: string): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  }
}

/**
 * 從 localStorage 讀取語系
 * @returns 儲存的語系代碼，如果沒有則返回 null
 */
export function getSavedLocale(): string | null {
  if (typeof window !== 'undefined') {
    return localStorage.getItem(LOCALE_STORAGE_KEY);
  }
  return null;
}

/**
 * 清除儲存的語系
 */
export function clearSavedLocale(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(LOCALE_STORAGE_KEY);
  }
}
